import { PB } from '../constants/measure';
import DNOServiceClient from '../common/clients/DNOServiceClient';

export const SET_PB_CONTENT = 'SET_PB_CONTENT';

export const setPBContent = (content) => ({
    type: SET_PB_CONTENT,
    content,
});

export const fetchPBContent = () => (dispatch) => dispatch(DNOServiceClient.getMeasureMockedForm(PB.ASSESSMENT))
    .then((content) => {
        dispatch(setPBContent(content));
    });
